import React, { useContext } from "react";
import EventBadges from "../EventBadges";
import WeekDayEventTime from "./WeekDayEventTime";
import PrivateEventBadge from "../PrivateEventBadge";
import { sortEventsWithAllDayFirst } from "../../../../helpers/calendar";
import CalendarLinkingContext from "../../../../contexts/CalendarLinkingContext";

/**
 * @param {Array} events
 * @param {Object} day
 * @param {boolean} useEventAccent
 * @param {boolean} isPills
 * @param {boolean} isStack
 * @param {boolean} showRecurring
 * @param {boolean} showFeatured
 * @param {string} calendarSlug
 * @param {boolean} showLocation
 * @param {boolean} embedded
 */
const WeekDayEvents = (props) => {
  const { events, day } = props;

  const { getEventUrl, onClickEvent } = useContext(CalendarLinkingContext);
  return (
    <div className="weekly-cal--day__event_container ">
      {events.sort(sortEventsWithAllDayFirst).map((event, edx) => {
        const inlineStyles = {};

        const eventUrl = getEventUrl(event);

        if (props.useEventAccent && event.accentColor) {
          if (props.isPills) {
            inlineStyles.backgroundColor = event.accentColor;
            // inlineStyles.color = event.fontColor;
          } else if (props.isStack) {
            inlineStyles.borderColor = event.accentColor;
          }
        }

        const isRecurring = event.recurrence_description && props.showRecurring;

        const badges = (
          <EventBadges
            showFeaturedBadge={props.showFeatured && event.is_featured}
            showRecurringBadge={props.showRecurring && isRecurring}
          />
        );

        const privateEventBadge =
          event.is_private * 1 == 1 && !props.embedded ? (
            <PrivateEventBadge />
          ) : null;

        const location =
          props.showLocation && event.display_location ? (
            <span className={"weekly-cal--day__event-location"}>
              {event.display_location}
            </span>
          ) : null;

        return (
          <a
            key={"wde" + edx}
            className={"weekly-cal--day__event"}
            onClick={onClickEvent(event)}
            style={inlineStyles}
            href={eventUrl}
          >
            {privateEventBadge}
            {badges}

            <span className={"weekly-cal--day__event-desc"}>
              {location}
              <span className={"time"}>
                <WeekDayEventTime event={event} day={day} />
              </span>
              <span className={"weekly-cal--day__event-name"}>
                {event.name}
              </span>
            </span>
          </a>
        );
      })}
    </div>
  );
};

export default WeekDayEvents;
